import { render, staticRenderFns } from "./Jbzl.vue?vue&type=template&id=3fe9dddc&scoped=true&"
import script from "./Jbzl.vue?vue&type=script&lang=js&"
export * from "./Jbzl.vue?vue&type=script&lang=js&"
import style0 from "./Jbzl.vue?vue&type=style&index=0&id=3fe9dddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe9dddc",
  null
  
)

export default component.exports